import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Radio, RadioGroup } from 'rsuite';
import { avatars } from '@shared/static/avatars';
import { FormGroup } from '@shared/ui/forms/display';

const EXCLUDED_AVATARS = ['default', 'tg ads'];

export default function AvatarPicker({ control }) {
  const { t } = useTranslation();

  const avatarColorWatch = useWatch({
    control,
    name: 'avatar.color',
  });

  return (
    <FormGroup label={t('avatar')}>
      <Controller
        control={control}
        name="avatar.name"
        render={({ field }) => (
          <RadioGroup
            className="radio-avatar-group"
            name="avatar-name"
            value={field.value}
            onChange={field.onChange}
          >
            {Object.entries(avatars)
              .filter(([key]) => !EXCLUDED_AVATARS.includes(key))
              .map(([key, value]) => (
                <Radio
                  key={key}
                  value={key}
                  style={{ '--svg-color': avatarColorWatch }}
                >
                  {value}
                </Radio>
              ))}
          </RadioGroup>
        )}
      />
    </FormGroup>
  );
}
